import axios from "axios";

axios.defaults.xsrfCookieName = "MYGREENHOUSE-XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
